export default "__VITE_ASSET__DZEpPUq1__"